import { PostItemController } from './post-item.controller'

const component = {
  templateUrl: '/posts/components/post-item/post-item.html?$$REVISION$$',
  bindings: {
    post: '=',
    onPinPostChange: '&',
    onAnalyticsPostResults: '&',
    onComplete: '&',
    pricing: '='
  },
  controllerAs: '$ctrl',
  controller: PostItemController
}

export const postItem = component
